import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { clearObj, formatDatesInPayload } from '@marfa/bo-utils';
import { PaymentListItem } from '@/models/payment/payment-list-item.model';
import { ResponseWithHeaders } from '@/models/common/response-with-header.model';
import { RequestListPayload } from '@/models/common/request-list-payload.model';
import { PaymentListDateFilterKeyList, PaymentListFilter } from '@/models/payment/payment-list-filter.model';

export default class GetPaymentListRequest extends ApiResourceMethod<ResponseWithHeaders<PaymentListItem[]>> {
  public perform(
    whitelabelSlug: string, params: RequestListPayload<PaymentListFilter>,
  ): Promise<ResponseWithHeaders<PaymentListItem[]>> {
    const requestData = { ...params };

    if (requestData.filterList && Object.keys(requestData.filterList).length > 0) {
      requestData.filterList = formatDatesInPayload({
        payload: { ...requestData.filterList },
        isUnixToString: false,
        isIncludeTime: true,
      }, [
        PaymentListDateFilterKeyList.CREATED_AT_FROM,
        PaymentListDateFilterKeyList.CREATED_AT_TO,
        PaymentListDateFilterKeyList.UPDATED_AT_FROM,
        PaymentListDateFilterKeyList.UPDATED_AT_TO,
      ]);
    }

    return this.performer.requestWithMapper(
      {
        params: clearObj(requestData),
        url: `${whitelabelSlug}/payment`,
      },
      ({ data, headers }: BaseResponse<PaymentListItem[]>): ResponseWithHeaders<PaymentListItem[]> => ({
        data,
        headers,
      }),
    );
  }
}
